// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.outerDiv {
  height: 100vh;
  width: 100vw;
  display: flex;
  overflow: hidden;
  background: #ffffff;
  background-image: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/info+(1).png");
  background-size:100%;
}

.leftDiv {
  width: 60%;
  /* background-color: #ffffff; */
  padding: 30px 59px 0px 56px;
}
.loader {
    border: 4px solid #f3f3f3; 
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
    margin: auto; 
  }
  
  .input:-webkit-autofill {-webkit-transition: background-color 5000s ease-in-out 0s;transition: background-color 5000s ease-in-out 0s;}



  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
.rightDiv {
  /* width: 40%; */
  /* position: relative; */
}

.formRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
#submitBtn{
    display: flex;
    justify-content:end;
    margin-right: 230px;
}
.formRow button{
    margin-right: 30px;

  }

  .inputGroup {
    flex: 1 1;
    margin-right: 30px;
    position: relative;
  }
  
  .inputGroup .error {
    color: red;
    font-size: 12px;
    position: absolute; 
  }
  
  .inputGroup input[type="text"],
  .inputGroup input[type="tel"],
  .inputGroup input[type="email"],
  .inputGroup input[type="date"],
  .inputGroup input[type="number"],
  .inputGroup textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 5px; 
    color: #fff;
    background-color: unset;
  }
  
  .inputGroup textarea {
    height: auto;
    box-sizing: border-box;
  }  
  
  .inputGroup label {
    display: block;
    color: #FFF;
    font-family: "Gothic A1";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 5px;
  }
  
  .inputGroup input,
  .inputGroup textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  button[type="submit"] {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
  }
  
  
.registerHeading {
  color: #fff;
  font-family: "Gothic A1" !important;
  font-size: 28px;
  font-style: normal;
  font-weight: 900 !important;
  margin-bottom: 28px;
}

.register_race_join_btn_div {
  cursor: pointer;
}
.register_race_join_btn_overlay1 {
  width: 203px;
  height: 49px;
  position: absolute;
  z-index: 1;
  border: 1px solid #fff;
  background: none;
}

.register_race_join_btn_div > button {
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.5rem 2rem;
  background: none;
  position: absolute;
  z-index: 2;
  width: 203px;
  height: 49px;
  padding: 4px 0 0 0;
  margin: -5px 0 0 -5px;
}


  

  .overlay img {
    height: 112px;
    width: 112px;
    margin-bottom: 40px;
  }
  .tahnkyouheader{
    color: #FFF;
    font-family: "Gothic A1";
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
    margin-bottom: 10px;
  }
  .thankyousubheader{
    color: #FFF;
    text-align: center;
    font-family: "Gothic A1";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  

@media (max-width: 600px) {
  .outerDiv{
    background-color: black;
  }
  .rightDiv {
    display: none;
  }

  .leftDiv {
    width: 100%;
    overflow-y: auto;
    padding: 30px 0px 180px 0px;
    background-color: black;
  }
  .formRow {
    flex-direction: column; 
    padding: 0px 16px;
    margin-bottom: 0px !important;
  }

  .inputGroup {
    margin-right: 0; 
  }

  .inputGroup input,
  .inputGroup textarea {
    width: 100%; 
    background-color: black;

  }

  .inputGroup label {
    margin-top: 10px; 
  }
.registerHeading{
  padding: 0px 16px 0px 16px;
}
  #submitBtn {
    margin-right: 0px !important;
    padding-top: 16px;
  }
  .mainButton{
    display: flex;
    justify-content: center;
    position: fixed;
    width: 100%;
    background-color: white;
    bottom: 0px;
    height: 100px;
    /* height: 30px; */
  }
  .register_race_join_btn_overlay1 {
    width: 203px;
    height: 49px;
    position: relative !important;
    z-index: 1;
    border: 1px solid black;
    border-radius: none !important;
    background: none;
  }
  .register_race_join_btn_overlay2 {
   display: none !important;
  }
  
  .register_race_join_btn_div > button {
    border: 1px solid black;
    color: black;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 0px !important;
    background: none;    position: relative !important;
    transform: translate(10px , -38px);
    z-index: 2;
    width: 203px;
    height: 49px;
    padding: 4px 0 0 0;
    margin: -5px 0 0 -5px;
  }
}


/* styles.css */

/* Style for the container div with background image */
.container {
  position: relative;
  width: 100%;
  height: 100vh; /* Full viewport height */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size:100%;
  
  
}

/* Style for the form inside the container */
/* form {
  width: 50%;
  background-color: rgba(255, 255, 255, 0.8); 
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
} */
`, "",{"version":3,"sources":["webpack://./src/features/register/register.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,+GAA+G;EAC/G,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;EACd;;EAEA,yBAAyB,yDAAiD,CAAjD,iDAAiD,CAAC;;;;EAI3E;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;AAEF;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;;EAEpB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;;;;IAME,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;;AAGF;EACE,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;;;;EAKE;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;;AAGF;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;;EAEzB;;EAEA;IACE,gBAAgB;EAClB;AACF;EACE,0BAA0B;AAC5B;EACE;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,UAAU;IACV,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;GACC,wBAAwB;EACzB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB,KAAK,6BAA6B;IAClD,kCAAkC;IAClC,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;;AAGA,eAAe;;AAEf,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,yDAA8C;EAC9C,oBAAoB;;;AAGtB;;AAEA,4CAA4C;AAC5C;;;;;;GAMG","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.outerDiv {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  overflow: hidden;\n  background: #ffffff;\n  background-image: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/info+(1).png\");\n  background-size:100%;\n}\n\n.leftDiv {\n  width: 60%;\n  /* background-color: #ffffff; */\n  padding: 30px 59px 0px 56px;\n}\n.loader {\n    border: 4px solid #f3f3f3; \n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n    margin: auto; \n  }\n  \n  .input:-webkit-autofill {transition: background-color 5000s ease-in-out 0s;}\n\n\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n.rightDiv {\n  /* width: 40%; */\n  /* position: relative; */\n}\n\n.formRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n#submitBtn{\n    display: flex;\n    justify-content:end;\n    margin-right: 230px;\n}\n.formRow button{\n    margin-right: 30px;\n\n  }\n\n  .inputGroup {\n    flex: 1;\n    margin-right: 30px;\n    position: relative;\n  }\n  \n  .inputGroup .error {\n    color: red;\n    font-size: 12px;\n    position: absolute; \n  }\n  \n  .inputGroup input[type=\"text\"],\n  .inputGroup input[type=\"tel\"],\n  .inputGroup input[type=\"email\"],\n  .inputGroup input[type=\"date\"],\n  .inputGroup input[type=\"number\"],\n  .inputGroup textarea {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-bottom: 5px; \n    color: #fff;\n    background-color: unset;\n  }\n  \n  .inputGroup textarea {\n    height: auto;\n    box-sizing: border-box;\n  }  \n  \n  .inputGroup label {\n    display: block;\n    color: #FFF;\n    font-family: \"Gothic A1\";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin-top: 5px;\n  }\n  \n  .inputGroup input,\n  .inputGroup textarea {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  button[type=\"submit\"] {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 20px;\n  }\n  \n  \n.registerHeading {\n  color: #fff;\n  font-family: \"Gothic A1\" !important;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 900 !important;\n  margin-bottom: 28px;\n}\n\n.register_race_join_btn_div {\n  cursor: pointer;\n}\n.register_race_join_btn_overlay1 {\n  width: 203px;\n  height: 49px;\n  position: absolute;\n  z-index: 1;\n  border: 1px solid #fff;\n  background: none;\n}\n\n.register_race_join_btn_div > button {\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0.5rem 2rem;\n  background: none;\n  position: absolute;\n  z-index: 2;\n  width: 203px;\n  height: 49px;\n  padding: 4px 0 0 0;\n  margin: -5px 0 0 -5px;\n}\n\n\n  \n\n  .overlay img {\n    height: 112px;\n    width: 112px;\n    margin-bottom: 40px;\n  }\n  .tahnkyouheader{\n    color: #FFF;\n    font-family: \"Gothic A1\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-transform: capitalize;\n    margin-bottom: 10px;\n  }\n  .thankyousubheader{\n    color: #FFF;\n    text-align: center;\n    font-family: \"Gothic A1\";\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  \n\n@media (max-width: 600px) {\n  .outerDiv{\n    background-color: black;\n  }\n  .rightDiv {\n    display: none;\n  }\n\n  .leftDiv {\n    width: 100%;\n    overflow-y: auto;\n    padding: 30px 0px 180px 0px;\n    background-color: black;\n  }\n  .formRow {\n    flex-direction: column; \n    padding: 0px 16px;\n    margin-bottom: 0px !important;\n  }\n\n  .inputGroup {\n    margin-right: 0; \n  }\n\n  .inputGroup input,\n  .inputGroup textarea {\n    width: 100%; \n    background-color: black;\n\n  }\n\n  .inputGroup label {\n    margin-top: 10px; \n  }\n.registerHeading{\n  padding: 0px 16px 0px 16px;\n}\n  #submitBtn {\n    margin-right: 0px !important;\n    padding-top: 16px;\n  }\n  .mainButton{\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    width: 100%;\n    background-color: white;\n    bottom: 0px;\n    height: 100px;\n    /* height: 30px; */\n  }\n  .register_race_join_btn_overlay1 {\n    width: 203px;\n    height: 49px;\n    position: relative !important;\n    z-index: 1;\n    border: 1px solid black;\n    border-radius: none !important;\n    background: none;\n  }\n  .register_race_join_btn_overlay2 {\n   display: none !important;\n  }\n  \n  .register_race_join_btn_div > button {\n    border: 1px solid black;\n    color: black;\n    font-size: 1rem;\n    font-weight: 600;\n    border-radius: 0px !important;\n    background: none;    position: relative !important;\n    transform: translate(10px , -38px);\n    z-index: 2;\n    width: 203px;\n    height: 49px;\n    padding: 4px 0 0 0;\n    margin: -5px 0 0 -5px;\n  }\n}\n\n\n/* styles.css */\n\n/* Style for the container div with background image */\n.container {\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Full viewport height */\n  background-image: url(\"../../assets/info.png\");\n  background-size:100%;\n  \n  \n}\n\n/* Style for the form inside the container */\n/* form {\n  width: 50%;\n  background-color: rgba(255, 255, 255, 0.8); \n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
